import * as React from 'react'
import {ErrorProps} from './ResidentHocInputErrorHandling'
import {createErrorHandlingForm, ErrorHandlingFormProps} from '../hoc/createResidentErrorHandlingForm'
import {CustomResidentTextFieldStyle} from '../../../../styledComponents/residentPage/TextField'
import styled from 'styled-components'
import {InputErrorProps} from '../../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../../styledComponents/StyledTypeDefinitions'
import {Colors} from '../../../../styledComponents/Constants'
import {IconButton} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import CancelIcon from '@mui/icons-material/Cancel'

interface Props {
    inputProps: React.InputHTMLAttributes<HTMLInputElement>
    icon: React.ReactNode
    onChange?: (event: any, checked?: boolean) => void
    onCansel: (event: any, checked?: boolean) => void
}

export const TextWithClearForResident = (props: Props & ErrorHandlingFormProps & ErrorProps) => {
    const {
        inputProps, hasError, clearErrorMessage, eventKeys,
        eventEmitter, errorAreaMaxWidth, onCansel, icon,
        ...rest
    } = props

    return <TextContainer>
        <IconContainer>
            {icon}
        </IconContainer>
        <input
            {...inputProps}
            {...rest}
            type={'text'}
        />
        {inputProps.value &&
            <VisibilityIconButton onClick={onCansel}>
                <StyledNotInterestedIcon/>
            </VisibilityIconButton>
        }
    </TextContainer>
}
TextWithClearForResident.displayName = 'TextWithClearForResident'


const TextContainer = styled.div`
    display: flex;
    background-color: ${Colors.Surface};
    align-items: center;
    border: 1px solid ${Colors.AccentLight};
    border-radius: 4px;
    padding: 0 15px;

    &:focus-within {
        border-color: ${Colors.AccentDark};
    }
`

const CustomTextFieldForResident = styled(TextWithClearForResident)<InputErrorProps>`
    ${CustomResidentTextFieldStyle};
    border: none;
    padding: 5px;
    height: 34px;

    &:-webkit-autofill {
        box-shadow: 0 0 0 1000px ${Colors.Surface} inset !important;
    }
`

const IconContainer: StyledDiv = styled.div`
    display: flex;
    align-items: center;
    ${Colors.AccentLight}
`

const VisibilityIconButton = withStyles({
    root: {
        padding: 0,
        color: '#00000066'
    }
})(IconButton)

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '16px'
    }
})(CancelIcon)

export const PPTextWithClearForResident = createErrorHandlingForm(CustomTextFieldForResident)
